import { GetFeaturedCard } from "./GetFeaturedCard";

const FeaturedProfiles = () => {
  return <div className="grid gap-4 md:gap-6 md:grid-cols-2 lg:grid-cols-3 animate-fade-in">
    <GetFeaturedCard />
    <GetFeaturedCard />
    <GetFeaturedCard />
  </div>

}

export default FeaturedProfiles;


//<FeaturedProductCard
//  title="Sue London"
//  subtitle="Author"
//  description="Keeping readers awake all night since 2013"
//  link="https://bysuelondon.com/?utm_source=bskyinsights"
//  linkText="Learn More"
//  avatar="https://cdn.bsky.app/img/avatar/plain/did:plc:autzu62d4yfjv3onffne4e2m/bafkreifbx4gbj4dfff73nkg5t3dcbh7hqgkevuvmkvpeyei76w6jnxdmy4@jpeg"
///>
//<FeaturedProductCard
//  title="handles.net"
//  description="Automatically provision and manage Bluesky handles for your team"
//  link={`https://handles.net/?utm_source=bskyinsights&utm_campaign=our_sponsors`}
//  linkText="Learn More"
//  avatar="https://cdn.bsky.app/img/avatar/plain/did:plc:uxliuappmohweip3b7jyqw44/bafkreibl2ndm7c43epmz6sufegff7zh3ua6dnagommaqiz5guovzdrndcu@jpeg"
///>
